import { render } from "./EditStaffTaskList.vue?vue&type=template&id=138146dc"
import script from "./EditStaffTaskList.vue?vue&type=script&lang=js"
export * from "./EditStaffTaskList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__